import DZModelPage from "@/model/DZModelPage";
import nyNetwork from "@/api/nyBaseNetwork";
import DZModelSetting from "@/views/系统设置/model/DZModelSetting";

class DZServiceSetting {

    list_setting : Array<DZModelSetting> = [];

    m_setting = new DZModelSetting();

    m_page = new DZModelPage(10);

    net_list_setting(){
        nyNetwork.net("系统设置分页",this.m_page, data => {
            this.list_setting = data.list
            this.m_page.total = data.total
        })
    }

    net_add_setting(success: () => void){
        nyNetwork.net("添加系统设置",this.m_setting, data => {
            success()
        })
    }

    net_edit_setting(success: () => void){
        nyNetwork.net("编辑系统设置",this.m_setting, data => {
            success()
        })
    }
}
export default DZServiceSetting;
